export const environment = {
  production: false,
  //apiUrl: 'http://localhost:8080/bilali-islamic-shopping/api'
  apiUrl: 'https://bilaliislamicshopping.krminfotech.com/api'
};
